import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import InnerLayout from "../innerLayout/InnerLayout";
import './Channels.css';
import {Button} from "../../components/Button";
import { CenterModal, RightModal, SmallModal } from "../../components/sideModal/Modal";
import IconButton from "../../components/iconButton/IconButton";
import Search from "../../components/search/Search";
import  {FormRow, FormInput, SelectOption, FormSelect } from "../../components/formRow/FormRow";
import FormMultiSelect from "../../components/formRow/FormMultiSelect";
import { Guid } from "../../../api/baseApi";
import { getUnassignedPlayers, unassigneChannelFromPlayer } from "../../../api/playersApi";
import { Channel, ChannelPlayerModel, createChannel, CreateChannelRequest, DayOfWeek, deleteChannel, enableTimeSlots as addTimeSlot, getChannelPlayers, getChannels, getChannelTimeSlots, removeTimeSlots as removeTimeSlot, TestEnum, TimeSlotModel, updateChannel, UpdateChannelRequest, enableRangeOfTimeSlots, EnableRangeOfTimeSlots } from "../../../api/channelsApi";
import Schedule from "../../components/schedule/Schedule";
import { addLeadingZero, formatDuration } from "../../../services/common";
import { formatDate, formatTime } from "../../../services/dateService";
import { createPathWithId, Routes } from "../../../constants/routes";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import Pagination from "../../components/pagination/Pagination";
import { getPagesCount } from "../../../services/paginator";
import { getCampaignsBase } from "../../../api/campaingsApi";
import CustomSelect, { CustomSelectOption } from "../../components/customSelect/CustomSelect";
import { MultiValue, SingleValue } from "react-select";
import { currentUserHasPermission, Permission } from "../../../api/authApi";


export interface ChannelsProps  extends RouteComponentProps<any>
{
    logOut : () => void;
    toogleCollapse : () => void;
    isCollapsed: boolean;
}

export type ChannelsState = 
{
    options: SelectOption[],
    selectedItems: string[],

    showModal: boolean,
    showScheduleModal: boolean,
    showMediaInfoModal: boolean,
    showChannelPlayerListModal: boolean,

    channelName: string,
    isChannelNameError: boolean,
    dayOfWeekUpdate: string,
    isDayOfWeekUpdateError: boolean,
    timeOfUpdate: string,
    isTimeOfUpdateError: boolean
    id: Guid,
    playerIds: Guid[],

    channels: Channel[],

    campaignsOption: CustomSelectOption[],
    selectedCampaignOption: Guid,
    
    timeSlots: TimeSlotModel[],
    timeSlotChannelId: Guid,

    channelPlayers: ChannelPlayerModel[],

    showSmallModal: boolean,
    playerToDeleteId: Guid,

    showSmallModalDelete: boolean,
    channelToDeleteId: Guid,

    searchString: string,
    currentPage: number,
    channelToDeleteName: string,
    isLoading: boolean
}

class Channels extends React.Component<ChannelsProps, ChannelsState> {
    constructor(props: ChannelsProps) {
        super(props);
        this.state = {
            isChannelNameError: false,
            isDayOfWeekUpdateError: false,
            isTimeOfUpdateError: false,
            options: [],
            selectedItems: [],
            showModal: false,
            showScheduleModal: false,
            showMediaInfoModal: false,
            showChannelPlayerListModal: false,
            channelName: "",
            dayOfWeekUpdate: "",
            timeOfUpdate: "",
            id: "",
            playerIds: [],

            channels: [],
            timeSlots: [],
            timeSlotChannelId: "",

            campaignsOption: [],
            selectedCampaignOption: '',

            channelPlayers: [],

            showSmallModal: false,
            playerToDeleteId: '',

            showSmallModalDelete: false,
            channelToDeleteId: '',

            searchString: '',
            currentPage: 1,
            channelToDeleteName: '',
            isLoading: false
        };
    }
    daysOfWeek : SelectOption[] = [
        {name: "Monday", value: `${DayOfWeek.Monday}`},
        {name: "Tuesday", value: `${DayOfWeek.Tuesday}`},
        {name: "Wednesday", value: `${DayOfWeek.Wednesday}`},
        {name: "Thursday", value: `${DayOfWeek.Thursday}`},
        {name: "Friday", value: `${DayOfWeek.Friday}`},
        {name: "Saturday", value: `${DayOfWeek.Saturday}`},
        {name: "Sunday", value: `${DayOfWeek.Sunday}`},
    ];

    channelsPerPage = 20;
    
    override async componentDidMount(){
        await Promise.all([this.updateChannels(), this.updateCampaigns()])
    }

    updateChannels = async (campaignId?: Guid) => {
        this.setState({isLoading:true});
        let result;
        if(campaignId){
            result = await getChannels(campaignId);
        } else {
            result = await getChannels();
        }
        if(result.type == "succes") this.setState({ channels: result.data.items });
        this.setState({isLoading:false});
    }

    updateCampaigns = async () => {
        this.setState({isLoading:true});
        var result = await getCampaignsBase();
        if(result.type == "succes") this.setState({ campaignsOption: result.data.items.map(it => {
            return {value: it.id, name:it.name}
        }) });
        this.setState({isLoading:false});
    }
    
    openModal = async (id: Guid, name: string, playerIds: Guid[], dayOfUpdate: string, timeOfUpdate: string) =>{  
        var getPlayersResult = await getUnassignedPlayers(id);
        if(getPlayersResult.type == "succes"){
            var options = getPlayersResult.data.unassignedPlayers.map(it =>{ return {name: it.name, value: it.id} });
            this.setState({
                showModal: true, 
                channelName: name, 
                id: id,
                playerIds: playerIds, 
                options: options,
                dayOfWeekUpdate: dayOfUpdate === null ? "" : `${dayOfUpdate}`,
                timeOfUpdate: timeOfUpdate,
                isDayOfWeekUpdateError: false,
                isTimeOfUpdateError: false, 
                isChannelNameError: false}); 
        }      
    };

    openScheduleModal = async (id: Guid) => { 
        var getTimeSlotsResult = await getChannelTimeSlots(id);
        if(getTimeSlotsResult.type == "succes"){
            this.setState({showScheduleModal: true, timeSlots: getTimeSlotsResult.data.items, timeSlotChannelId: id});
        }
    };

    openChannelPlayerListModal = async (id: Guid) => { 
        let channelPlayersResult = await getChannelPlayers(id);
        if(channelPlayersResult.type == "succes"){
            this.setState({
                showChannelPlayerListModal: true,
                channelPlayers: channelPlayersResult.data.items
            })
        }
    };

    closeModal = () => { this.setState({showModal: false, isChannelNameError: false})};

    closeScheduleModal = () => { this.setState({showScheduleModal: false})};

    closeMediaInfoModal = () => { this.setState({showMediaInfoModal: false})};

    closeSmallModal = () => this.setState({showSmallModal: false});

    closeSmallModalDelete = () => this.setState({showSmallModalDelete: false});


    closeChannelPlayerListModal = () => { this.setState({showChannelPlayerListModal: false})};

    onAdd = (value: string)             => this.setState({ selectedItems: [...this.state.selectedItems, value] });

    omRemove = (value: string)          => this.setState({ selectedItems: [...this.state.selectedItems.filter(it => it != value)] });

    setChannelName = (newName: string)  => this.setState({ channelName: newName, isChannelNameError: false}); 

    addPlayer = (id: Guid)              => this.setState({ playerIds: [...this.state.playerIds, id]});

    removePlayer = (id: Guid)           => this.setState({ playerIds: this.state.playerIds.filter(it => it !== id)});


    onTimeSlotAdd = async (timeSlot: TimeSlotModel) => {
        var result = await addTimeSlot({...timeSlot}, this.state.timeSlotChannelId);
        if(result.type == "succes"){
            this.setState({timeSlots : [...this.state.timeSlots, {...timeSlot, id: result.data.id}]});    
        }
    }

    onTimeSlotRemove = async (id: Guid) => {
        await removeTimeSlot(this.state.timeSlotChannelId, id);
        this.setState({timeSlots : this.state.timeSlots.filter(it => it.id !== id)});     
    }

    removePlayerFromChannel = async (id: Guid) => { 
        this.setState({ showSmallModal: true, playerToDeleteId: id });
    }

    agreeRemovePlayerFromChannel = async () => {
        this.setState({ showSmallModal: false });
        let response = await unassigneChannelFromPlayer(this.state.playerToDeleteId);
        if(response.type == "succes"){
            this.setState({
                channelPlayers: this.state.channelPlayers.filter(it => it.id !== this.state.playerToDeleteId)
            });
            this.updateChannels(this.state.selectedCampaignOption);
        }
    }

    removeChannel = async (id: Guid, name: string) => { 
        this.setState({ showSmallModalDelete: true, channelToDeleteId: id, channelToDeleteName: name });
    }

    agreeDeleteChannel = async () => {
        this.setState({ showSmallModalDelete: false });
        let response = await deleteChannel(this.state.channelToDeleteId);
        if(response.type == "succes"){
            this.setState({
                channels: this.state.channels.filter(it => it.id !== this.state.channelToDeleteId)
            });
            this.updateChannels(this.state.selectedCampaignOption);
        }
    }

    save = async () => {
        var isError = false;
        if(!this.state.channelName) { this.setState({isChannelNameError : true}); isError = true; }

        if(isError) return;
        if(!!this.state.id){
            const updateRequest: UpdateChannelRequest = { 
                id : this.state.id, 
                name: this.state.channelName, 
                playerIds: this.state.playerIds,
                dayOfUpdate: this.state.dayOfWeekUpdate === "" ? null : Number(this.state.dayOfWeekUpdate),
                timeOfUpdate: this.state.timeOfUpdate
            };
            await updateChannel(updateRequest);
        }
        else{
            const createRequest: CreateChannelRequest = { 
                name: this.state.channelName, 
                playerIds: this.state.playerIds,
                dayOfUpdate: this.state.dayOfWeekUpdate === "" ? null : Number(this.state.dayOfWeekUpdate),
                timeOfUpdate: this.state.timeOfUpdate
            };
            await createChannel(createRequest);
        }

        var result = await getChannels(this.state.selectedCampaignOption);
        if(result.type == "succes") this.setState({ channels: result.data.items });
        this.closeModal();
    }

    setSeatchString = (searchStr: string) => this.setState({searchString: searchStr, currentPage: 1});

    getFilteredBySearch = () => this.state.searchString === '' ? 
        this.state.channels : 
        this.state.channels.filter( it => !!it.name && it.name.toLowerCase().includes(this.state.searchString.toLowerCase()));

    getPagesNumber = () => {
        let length = this.getFilteredBySearch().length;
        return getPagesCount(length, this.channelsPerPage)
    }

    changePaginationPage = (page: number) => this.setState({currentPage: page});

    getChannelsToDisaplay = () => {
        let filterdChannels = this.getFilteredBySearch();
        let startIndex = (this.state.currentPage - 1)*this.channelsPerPage;
        let finishIndex = startIndex + this.channelsPerPage;
        return filterdChannels.slice(startIndex, finishIndex) 
    }

    renderChannelRow = (channel : Channel) => {
        let isExternalOrganisationUser = currentUserHasPermission(Permission.ExternalOrganisationUser);
        return <tr key={channel.id}>
                    <td>{channel.name}</td>
                    {!isExternalOrganisationUser && <td>{channel.playersIds.length}</td>}
                    <td>{channel.mediaItems} in {channel.playlistsCount} Playlist{channel.playlistsCount > 1 ? "s" : ""}</td>
                    <td>{channel.unassignedMediaCount ?? channel.unassignedMedias ?? 0}</td>
                    <td>{formatDuration(channel.durationMs)}</td>
                    <td>
                        {!isExternalOrganisationUser && <IconButton type="clock" tooltipText="Daypart" onClick={() => this.openScheduleModal(channel.id)} />}
                        {!isExternalOrganisationUser && <IconButton type="player" tooltipText="Players" onClick={() => this.openChannelPlayerListModal(channel.id)} />}
                        {!isExternalOrganisationUser && <IconButton type="edit" tooltipText="Edit" onClick={() => this.openModal(channel.id, channel.name, channel.playersIds, channel.dayOfUpdate, channel.timeUpdate)}/>}
                        <IconButton type="list-add" tooltipText="Media" onClick={()=>{this.props.history.push(createPathWithId(Routes.Channels, channel.id))}}/>
                        {!isExternalOrganisationUser && <IconButton type="delete" tooltipText="Delete" onClick={()=>{this.removeChannel(channel.id, channel.name)}}/>}
                    </td>
                </tr>
    }

    renderChannelPlayerRow = (it: ChannelPlayerModel, index: number) => {
        return  <tr key={it.id}>
                    <td>{addLeadingZero(index + 1, 2)}</td>
                    <td>{it.name} <span className="player-id-span">ID: {it.id}</span></td>
                    <td>{it.tags.map( tag => <span key={tag.id} className="tag-name">{tag.name}</span>)}</td>
                    <td>{formatDate(it.lastSeen)} - {formatTime(it.lastSeen)}</td>
                    <td>{it.location}</td>
                    <td>
                        <IconButton tooltipText="Remove" tooltipPosition="left" type="minus" onClick={()=>{this.removePlayerFromChannel(it.id)}} />
                    </td>
                </tr>
    }

    onSelectedCampaignOption = async (newValue : any) => {
        if(newValue){
            await this.updateChannels(newValue.value)
            this.setState({selectedCampaignOption: newValue.value})
        } else {
            await this.updateChannels()
            this.setState({selectedCampaignOption: ''})
        }
        this.setState({currentPage:1})
    }

    onTimeSlotRangeSelect = async (slots:EnableRangeOfTimeSlots) => {
        await enableRangeOfTimeSlots(slots, this.state.timeSlotChannelId)
        let getTimeSlotsResult = await getChannelTimeSlots(this.state.timeSlotChannelId);
        if(getTimeSlotsResult.type == "succes"){
            this.setState({timeSlots: getTimeSlotsResult.data.items});
        }
    }

    render() {
        let isExternalOrganisationUser = currentUserHasPermission(Permission.ExternalOrganisationUser);
        let channelToDisplayLength = this.getChannelsToDisaplay().length
        return <InnerLayout 
                activeTab="channels" 
                logOut={this.props.logOut} 
                toogleCollapse={this.props.toogleCollapse}
                isCollapsed={this.props.isCollapsed}
                >
                <>  
                    <div className="d-flex justify-content-end align-items-center mb-20 pt-50">
                        <div className="d-flex align-items-center gap5" style={{width:"250px", marginRight:"15px"}}>
                            <CustomSelect 
                                isSort={true}
                                label="Campaigns"
                                options={this.state.campaignsOption}
                                className={`w-100`}
                                classNamePrefix={`select`}
                                filterOption={(option, input) => option.label.toLowerCase().includes(input.toLowerCase())}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option) => `${option.value}`}
                                onChange={this.onSelectedCampaignOption} 
                                isClearable={true}
                            /> 
                        </div>
                        <Search onChangeValue={this.setSeatchString}/>
                        {!isExternalOrganisationUser && <Button color="green"  label="Add Network" onClick={()=>{this.openModal("", "", [], "", "")}} />}
                    </div>

                    {channelToDisplayLength ? <table className="table">
                        <thead>
                            <tr>
                                <td>Networks</td>
                                {!isExternalOrganisationUser && <td>Players</td>}
                                <td>Media Items</td>
                                <td>Unassigned Media</td>
                                <td>Duration</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            {this.getChannelsToDisaplay().map( it => this.renderChannelRow(it))}
                        </tbody>                        
                    </table> : <p className="w-100 text-center">There are no Networks</p>}

                    <Pagination 
                        activePage={this.state.currentPage} 
                        pagesCount={this.getPagesNumber()} 
                        changePaginationPage={this.changePaginationPage} 
                    />

                    <RightModal  title={!!this.state.id ? "Edit": "Create"} show={this.state.showModal} onRequestClose={this.closeModal} >
                        <FormRow>
                            <FormInput 
                                errorMessage = "Please enter name"
                                id = "channel_name_input"
                                isError = {this.state.isChannelNameError}
                                title = "Network Name"
                                onChangeValue = {this.setChannelName}
                                onChange = {() => {}}
                                value = {this.state.channelName}
                            />
                        </FormRow>
                        <FormRow>
                            <FormSelect
                            errorMessage="Please select Day Of Week"
                            id="channel_dayofweek_input"
                            isError={false}
                            options={this.daysOfWeek}
                            onChange={(value) => this.setState({dayOfWeekUpdate: value, isDayOfWeekUpdateError: false})}
                            selectedValue={this.state.dayOfWeekUpdate}
                            title="Players Update Day of Week"
                            defaultValueText="Disable Autoupdate"
                            />                         
                        </FormRow>
                        <FormRow>
                        <FormInput 
                            title="Players Update Time" 
                            isError={false} 
                            errorMessage="Please select Time" 
                            type="time" 
                            id="channel_time_input" 
                            value={this.state.timeOfUpdate}
                            disabled={this.state.dayOfWeekUpdate == "" || this.state.dayOfWeekUpdate == null}
                            onChangeValue={(value) => this.setState({timeOfUpdate: value, isTimeOfUpdateError: false}) }></FormInput>
                        </FormRow>
                        <FormRow>
                                <FormMultiSelect
                                    id="players-list"
                                    title="Not Assigned Player"
                                    titleSelected="Selected Players"
                                    isError={false}
                                    errorMessage="Please select palyer"
                                    onAdd={this.addPlayer}
                                    onRemove={this.removePlayer}
                                    options={this.state.options}
                                    selectedOptions={this.state.playerIds}
                                />
                        </FormRow>
                        <div className="modal-btn-group">
                            <Button color="green" label="Save" onClick={this.save}/>
                            <Button color="gray" label="Cancel" onClick={this.closeModal}/>
                        </div>
                    </RightModal>   

                    <CenterModal title="Network Schedule" show={this.state.showScheduleModal} onRequestClose={this.closeScheduleModal}>
                        <Schedule 
                            timeSlots={this.state.timeSlots} 
                            onTimeSlotAdd={this.onTimeSlotAdd} 
                            onTimeSlotRemove={this.onTimeSlotRemove}
                            onTimeSlotRangeSelect={this.onTimeSlotRangeSelect}
                        />
                    </CenterModal> 

                    <CenterModal title="Network Player List" show={this.state.showChannelPlayerListModal} onRequestClose={this.closeChannelPlayerListModal}>
                        <table className="table channel-player-table">
                            <thead>
                                <tr>
                                    <td></td>
                                    <td>Player Name</td>
                                    <td>Tags</td>
                                    <td>Heart beat</td>
                                    <td>Location</td>
                                    <td></td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.channelPlayers.map(this.renderChannelPlayerRow)}
                            </tbody>
                        </table>
                    </CenterModal>
                    
                    <SmallModal show={this.state.showSmallModal} onRequestClose={this.closeSmallModal}> 
                        <div className="modal-btn-group">
                            <Button color="gray" label="Cancel" onClick={this.closeSmallModal}/>
                            <Button color="green" label="Yes" onClick={this.agreeRemovePlayerFromChannel}/>
                        </div>
                    </SmallModal>

                    <SmallModal show={this.state.showSmallModalDelete} onRequestClose={this.closeSmallModalDelete} text={`Delete `}> 
                    <p>That you want to delete network <b>{this.state.channelToDeleteName}</b>.</p>
                        <div className="modal-btn-group">
                            <Button color="gray" label="Cancel" onClick={this.closeSmallModalDelete}/>
                            <Button color="green" label="Yes" onClick={this.agreeDeleteChannel}/>
                        </div>
                    </SmallModal>
                    <GlobalSpinner isShow={this.state.isLoading} />
                </>
            </InnerLayout>
    }
}

export default withRouter(Channels);
